import React from "react";

import CategoryCard from "./CategoryCard";
import WelcomeSection from "./WelcomeSection";
import { ICategoryCard } from "../../../types/chat";

import { FilledChatIcon } from "../../icons/FilledChatIcon";
import { ClaimReviewIcon } from "../../icons/ClaimReviewIcon";
import { PreServiceReviewIcon } from "../../icons/PreServiceReviewIcon";
import { ContractResearchIcon } from "../../icons/ContractResearchIcon";

const categories = [
  {
    id: "policy-questions",
    icon: <FilledChatIcon />,
    title: "Policy Questions",
    description: "Ask about health insurer policies and coverage details",
    enabled: true,
  },
  {
    id: "appeal-claim",
    icon: <ClaimReviewIcon />,
    title: "Appeal a Claim",
    description: "Challenge denied claims with AI-powered appeal strategies",
    enabled: false,
  },
  {
    id: "contract-research",
    icon: <ContractResearchIcon />,
    title: "Contract Research",
    description: "Research payer contracts and reimbursement terms",
    enabled: false,
  },
  {
    id: "pre-service-review",
    icon: <PreServiceReviewIcon />,
    title: "Pre-Service Review",
    description: "Upload surgical scheduling documents",
    enabled: false,
  },
] as ICategoryCard[];

const CategoryCards: React.FC<{ hideCategories?: boolean }> = ({
  hideCategories,
}) => {
  return (
    <div className={`w-full min-w-0 max-w-layout-chat px-4 m-auto`}>
      <div className={`mb-12 mt-8`}>
        <WelcomeSection
          title="Welcome to your RCM AI Assistant"
          subtitle="Upload claims and medical records, ask policy questions, or generate appeal letters to get started."
        />
      </div>

      {hideCategories ? null : (
        <div
          className={`flex flex-wrap gap-x-3 gap-y-3 items-stretch justify-center max-w-xl mx-auto pb-4`}
        >
          {categories.map((category) => (
            <CategoryCard key={category.id} category={category} />
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryCards;
